import { useState,useEffect } from 'react';
import styles from './ChallengeBoard.module.css';
import ChallengeSubmissionForm from './ChallengeSubmissionForm';

// const challenges = [
//   {
//     id: 1,
//     title: "Build a property search UI",
//     description: "Create a frontend interface with filters, maps & bookmarks",
//     skills: "Frontend (React/Next.js)",
//     deadline: "5 Days"
//   },
//   {
//     id: 2,
//     title: "Create a backend API",
//     description: "Build a backend API to fetch/filter properties with MongoDB",
//     skills: "Backend (Node/Express)",
//     deadline: "5 Days"
//   },
//   {
//     id: 3,
//     title: "Design booking experience",
//     description: "Create a mobile-first booking experience",
//     skills: "UI/UX (Figma)",
//     deadline: "3 Days"
//   },
//   {
//     id: 4,
//     title: "Content suggestion engine",
//     description: "Build a content suggestion engine using AI",
//     skills: "Python, ML",
//     deadline: "7 Days"
//   },
//   {
//     id: 5,
//     title: "VR walkthrough prototype",
//     description: "Create a VR walkthrough prototype (optional)",
//     skills: "Unity/WebVR",
//     deadline: "10 Days"
//   }
// ];

export default function ChallengeBoard() {
  const [activeTab, setActiveTab] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [selectedChallenge, setSelectedChallenge] = useState(null);
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  const fetchChallenges = async () => {
    try {
      console.log("Fetching challenges...");
      const response = await fetch(`https://pp-backend-1-sa8p.onrender.com/api/careers/challenges`);

      if (!response.ok) {
        throw new Error(`Server responded with status: ${response.status}`);
      }
      
      const data = await response.json();
      setChallenges(data);
    } catch (error) {
      console.error('Error fetching challenges:', error);
      setError('Failed to load challenges. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  fetchChallenges();
}, []);


  const handleChallengeClick = (challenge) => {
    setSelectedChallenge(challenge);
    setShowForm(true);
  };

  const handleSubmit = (challengeId, formData) => {
    // Handle form submission
    console.log('Submitting:', challengeId, formData);
    alert(`Challenge #${challengeId} submitted successfully!`);
    setShowForm(false);
  };

  return (
    <section id='challenge' className={styles.challengeSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>The Plateau Challenge Board</h2>
        <p className={styles.sectionSubtitle}>Pick a challenge. Submit it. Get hired. That's it.</p>
      </div>
      
      <div className={styles.tabs}>
        <button 
          className={`${styles.tab} ${activeTab === 'all' ? styles.active : ''}`}
          onClick={() => setActiveTab('all')}
        >
          All Challenges
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'tech' ? styles.active : ''}`}
          onClick={() => setActiveTab('tech')}
        >
          Tech Challenges
        </button>
        <button 
          className={`${styles.tab} ${activeTab === 'creative' ? styles.active : ''}`}
          onClick={() => setActiveTab('creative')}
        >
          Creative Challenges
        </button>
      </div>
      
      <div className={styles.challengeGrid}>
        {loading && <p>Loading challenges...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}
        {!loading && !error && challenges.map(challenge => (
          <div key={challenge.id} className={styles.challengeCard}>
            <div className={styles.challengeHeader}>
              <span className={styles.challengeId}>#{challenge.id}</span>
              <h3 className={styles.challengeTitle}>{challenge.title}</h3>
            </div>
            <p className={styles.challengeDesc}>{challenge.description}</p>
            <div className={styles.challengeMeta}>
              <span className={styles.skills}>{challenge.skills}</span>
              <span className={styles.deadline}>{challenge.deadline}</span>
            </div>
            <button 
              className={styles.challengeCta}
              onClick={() => handleChallengeClick(challenge)}
            >
              Take This Challenge
            </button>
          </div>
        ))}
      </div>
      
      <div className={styles.process}>
        <h3 className={styles.processTitle}>How It Works</h3>
        <div className={styles.processSteps}>
          <div className={styles.step}>
            <div className={styles.stepNumber}>1</div>
            <h4>Pick a Challenge</h4>
            <p>Choose from our challenge board</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>2</div>
            <h4>Build & Submit</h4>
            <p>Submit your work via GitHub, Figma, or Loom</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>3</div>
            <h4>Get Feedback</h4>
            <p>We review and provide actionable feedback</p>
          </div>
          <div className={styles.step}>
            <div className={styles.stepNumber}>4</div>
            <h4>Get Hired</h4>
            <p>If you impress us, you're in!</p>
          </div>
        </div>
      </div>

      {showForm && selectedChallenge && (
        <ChallengeSubmissionForm 
          challenge={selectedChallenge}
          onClose={() => setShowForm(false)}
          onSubmit={handleSubmit}
        />
      )}
    </section>
  );
}